module.exports = __webpack_public_path__ + "static/img/11areaB_06.62a5ceb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_06.png
// module id = 1095
// module chunks = 1